/*
 * @Description: download
 * @Autor: lijinpeng
 * @Date: 2021-07-01 18:35:55
 * @LastEditors: lijinpeng
 */
import axios from 'axios';
import { Loading } from 'element-ui';
import nprogress from '@/utils/nprogress';
import { getToken } from '@/utils/auth';
import { saveAs } from 'file-saver';

// 创建axios实例
const service = axios.create({
  baseURL: '',
  timeout: 150000,
});
service.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
service.defaults.headers.post['admin-token'] = getToken();

let needLoadingRequestCount = 0;

let loading;

/*开启遮罩*/
function startLoading() {
  loading = Loading.service({
    customClass: 'axios-loading',
    lock: true,
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
  });
}

/*关闭遮罩*/
function endLoading() {
  if (loading) {
    loading.close();
  }
}

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    nprogress.start();
    _.debounce(startLoading, 301)();
  }
  needLoadingRequestCount++;
}

function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  nprogress.done();
  if (needLoadingRequestCount === 0) {
    _.debounce(endLoading, 300)();
  }
}

/**
 * @Description: 文件流转blob对象下载 encodeURI 编码、decodeURI 解码
 * @param : data  文件流
 * @param : type  type
 * @param : fileName  文件名
 */
export function downloadFileAndBlob({ url, method, data, params, fileName }) {
  return new Promise((resolve, reject) => {
    showFullScreenLoading();
    service({
      url,
      method,
      params,
      data,
      responseType: 'blob',
    })
      .then(res => {
        const { data } = res;
        if (res.headers['content-disposition']) {
          fileName = res.headers['content-disposition'].split(';')[1].split('filename=')[1];
        }
        const blob = new Blob([data]);
        saveAs(blob, decodeURI(fileName));
        resolve('已下载！');
      })
      .catch(error => {
        reject(new Error('下载失败！'));
      })
      .finally(() => {
        tryHideFullScreenLoading();
      });
  });
}
